<ion-select [attr.aria-label]="translationService.translate('SELECT_STORE')" class="ion-hide" #mySelect [placeholder]="translationService.translate('SELECT_STORE')"
  [interfaceOptions]="storeOptions" interface="alert" (ionChange)="setSelectedStore($event.target['value'])"
  [compareWith]="compareWith" [value]="selectedStore" [okText]="okText" [cancelText]="cancelText">
  @for (store of storeList; track $index) {
    <ion-select-option [value]="store">
      {{store?.storeName}}
    </ion-select-option>
  }
</ion-select>